import { render, staticRenderFns } from "./AdditionalFieldsMultiLanguageTextArea.vue?vue&type=template&id=2b0282c7&scoped=true&lang=pug&"
import script from "./AdditionalFieldsMultiLanguageTextArea.vue?vue&type=script&lang=ts&"
export * from "./AdditionalFieldsMultiLanguageTextArea.vue?vue&type=script&lang=ts&"
import style0 from "./AdditionalFieldsMultiLanguageTextArea.vue?vue&type=style&index=0&id=2b0282c7&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0282c7",
  null
  
)

export default component.exports